// Cheap, deterministic avatar with the user/contact initials. Picks a colour
// from a small palette based on a hash of the source string so the same name
// gets the same colour every time.

const PALETTE = [
  { bg: "#e0e7ff", fg: "#4338ca" },
  { bg: "#dcfce7", fg: "#166534" },
  { bg: "#fee2e2", fg: "#991b1b" },
  { bg: "#fde68a", fg: "#92400e" },
  { bg: "#dbeafe", fg: "#1d4ed8" },
  { bg: "#fce7f3", fg: "#9f1239" },
  { bg: "#cffafe", fg: "#0e7490" },
  { bg: "#ede9fe", fg: "#5b21b6" },
];

function hash(input: string): number {
  let h = 0;
  for (let i = 0; i < input.length; i++) h = (h * 31 + input.charCodeAt(i)) | 0;
  return Math.abs(h);
}

function initials(label: string): string {
  const parts = label.split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  const first = parts[0]?.[0] ?? "";
  const last = parts.length > 1 ? parts[parts.length - 1][0] : "";
  return (first + last).toUpperCase() || "?";
}

interface AvatarProps {
  name: string;
  size?: number;
  title?: string;
}

export function Avatar({ name, size = 36, title }: AvatarProps) {
  const safe = name.trim() || "?";
  const palette = PALETTE[hash(safe) % PALETTE.length];
  return (
    <div
      className="avatar"
      title={title ?? safe}
      style={{
        width: size,
        height: size,
        background: palette.bg,
        color: palette.fg,
        fontSize: Math.round(size / 2.5),
        flex: `0 0 ${size}px`,
      }}
    >
      {initials(safe)}
    </div>
  );
}
